export default "__VITE_ASSET__6ea14463__"